<template>
  <el-row id="multipleChoice">
    <el-dialog :style="{ '--el-dialog-padding-primary': 0 }" v-model="dialogMultipleChoiceVisible" :show-close="false" class="customDialog" width="900px" title="人员选择" :append-to-body='true' :close-on-click-modal='false' draggable>
      <!--组织 start-->
      <div style="border-top: 1px solid #D8D8D8"></div>
      <div class="box" v-if="dialogMultipleChoiceVisible">
        <div class="header">
          <div class="sub-menu-item" :class="showType===0?'menuActive':''" @click="onSwitchover(0)" v-if="!isorgs">组织</div>
          <div class="sub-menu-item" :class="showType===1?'menuActive':''" @click="onSwitchover(1)" v-if="!isrole">角色</div>
          <div v-if="approvalId" class="sub-menu-item" :class="showType===2?'menuActive':''" @click="onSwitchover(2)">
            常用
            <i class="iconfont icon-shezhi21" @click.stop="groupSet"></i>
          </div>
          <div class="role-select-item" v-if="isSpace && showType===1 && !hideChangeRole">
            <el-radio-group v-model="userSelect" @change="userSelectChange">
              <el-radio label="platform" v-if="userStatus === 3">平台角色</el-radio>
              <el-radio label="space">空间角色</el-radio>
            </el-radio-group>
          </div>
          <el-button v-if="showType === 2 && isGroup" @click="addGroup" style="position: absolute; right: 300px; top: 2px" type="primary" link >新增分组</el-button>
          <div class="search-item">
            <!-- @keyup.native="debounceInputSearch" -->
            <el-input placeholder='请输入姓名","分割多人查找' style="width:244px;" v-model="inputSearch" :disabled="isorgs&&isrole" clearable size="small" @clear="OnInputSearch" @keyup="debounceInputSearch">
            <template #append>
              <el-button @click="OnInputSearch">搜索</el-button>
            </template>
            </el-input>
            <a v-if="showBatch" class="btn-search" href="javascript:;" title="批量查找" @click="showBatchSearch"><i class="iconfont icon-kuaisuchazhao"></i></a>
          </div>
        </div>
        <div class="content">
          <div class="conbox" :style="isuser ? 'width:100%;height:380px' : 'width:436px;height:380px'" v-show="isuser||!inputSearch" v-if="!isorgs||!isrole">
            <group ref="userGruoup" v-show="showType === 2" :groupList="userGruoupList" :isGrouping="grouping" :approvalId='approvalId' :isGroup="isGroup" :isCto="channelFrom === 'cto'" :isEdit='isEditGroup' :checkedGroupArr="checkedGroupArr" @handleSelectGroup="checkGroup" @handleSelect="handleGroup" />
            <organize :isCheck="true && multipleChoiceParms.onlyUser" :isUserSpace="isSpace" :curSpace="curSpace" v-show="showType === 0" ref="organizeRef" @handleSelect="handleOrg" :maxCount="maxCount"></organize>
            <rolecom :isCheck="true && multipleChoiceParms.onlyUser" v-show="showType === 1" :isUserSpace="isSpace" :treekey="treekey" ref="rolecomRef" :userSelect="userSelect" @handleSelect="handleRole" :maxCount="maxCount"></rolecom>
          </div>
          <div class="conbox" v-if="!isuser" :class="(isorgs&&isrole)||inputSearch?'w100':'w437'">
            <usercom ref="usercomRef" :maxCount="maxCount" :isShowID="isShowID" :isGrouping="grouping" :approvalId="approvalId" :showType="showType" :parms="multipleChoiceParms" :isEditGroup="isEditGroup" />
          </div>
        </div>
      </div>
      <div class="box">
        <div class="header">
          <span>已选择({{onuserZise(checkedArrUser,checkedFlowArr,checkedRoleArr)}})</span>
          <el-button type="primary" link style="float:right" @click="handleEmpty">全部清除</el-button>
        </div>
        <el-scrollbar style="height:84px" class="el-menu-scrollbar__wrap">
          <div style="padding:3px">
            <el-tag closable type="primary" v-for="item in checkedFlowArr" @close="handleCloseFlow(item)" :key="item.organizationId" style="margin:3px">
              <el-tooltip effect="dark" :content="item.name" placement="top">
                <span>
                  {{ dealShowName(item) }} 
                  <span class="choose-type1">组织</span>
                </span>
              </el-tooltip>
            </el-tag>
            <el-tag closable type="primary" v-for="item in checkedGroupArr" @close="handleCloseGroup(item)" :key="item.id" style="margin:3px">
              <el-tooltip effect="dark" :content="item.name" placement="top">
                <span>
                  {{ dealShowName(item) }} 
                  <span class="choose-type1">分组</span>
                </span>
              </el-tooltip>
            </el-tag>
            <el-tag closable type="primary" v-for="item in checkedRoleArr" @close="handleCloseRole(item)" :key="item.roleId" style="margin:3px"><el-checkbox style="margin-right:4px;" v-if="isDefaultVal" v-model="item.checked"></el-checkbox>{{item.name}} <span class="choose-type2">角色</span></el-tag>
            <el-tag closable type="primary" v-for="item in checkedArrUser" @close="handleCloseUser(item)" :key="item.userId" style="margin:3px">{{item.realname || item.name}}</el-tag>
          </div>
        </el-scrollbar>
      </div>
      <div class="footer" ref="footer">
        <el-button @click="closeLevelSelect">取消</el-button>
        <el-button type="primary" @click="submit" :loading="isBtnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- <batch-search ref="batchSearchRef" @batchSearchChild="handleBatchSearchChild" /> -->
  </el-row>
</template>

<script>
import { axiosBase } from '@/api/api'
import group from './multipleChoice/group'
import organize from './multipleChoice/organize'
import rolecom from './multipleChoice/role'
import usercom from './multipleChoice/user'
import { getOrgShowName } from '@/api/global'
import { getuserlevel } from '@/port/personal/personal'
import { getopenuserlist } from '@/port/clientSide/multipleChoice'
import {
  addapprovaluserchose,
  adduserfolder,
  getuserlistbyfolder
} from '@/port/admins/relationUserGroup'
import { cloneDeep, debounce } from 'lodash'
export default {
  name: 'multipleChoice',
  data () {
    return {
      //公文流转
      props: {
          label: 'name',
          children: 'zones'
        },
      inputSearch: '',
      dialogMultipleChoiceVisible:false,
      showType: 0,
      isDefaultVal: false, // 是否可以勾选默认值
      isorgs:false, // true 不显示组织
      isrole:false, // true 不显示角色
      isGroup:false, 
      grouping: 0, // 常用分组 0：当前用户 1：当前应用
      isShowID: false, 
      relationMoreTag: '', // 显示标签
      isuser:false, // true 不显示用户
      showBatch: false, // 是否显示批量查找
      hideChangeRole: false, // 是否显示平台、空间角色切换
      channelFrom: '', // 来源
      key:null,
      radio_:false, // 是否单选
      maxCount: null, // 最大可选个数
      //组织架构的参数
      checkedFlowArr: [],
      settingOrg: {}, // 组织配置 项介绍在方法里面
      //用户参数
      checkedArrUser:[],
      checkedUser:[],
      //角色的参数
      checkedRoleArr: [],
      // 选中的分组
      checkedGroupArr: [],
      settingRole: {}, // 角色配置 项介绍在方法里面
      isEquired: false,//是否必选
      userSelect: 'platform', // 是否从空间里面的用户管理进来
      treekey: 0,
      userStatus: 0,
      approvalId: 0,
      isEditGroup: false,
      userGruoupList: [],
      multipleChoiceParms: {},
      batchSearhData: {},
      isBtnLoading: false
    }
  },
  props: {
    curSpace: {
      type: Object,
      default: ()=>({})  
    },
    isSpace: {
      type: Boolean,
      default: false
    },
    isUpace: {
      type: Boolean,
      default: false
    }
  },
  components:{
    group,
    organize,
    rolecom,
    usercom,
    // batchSearch: () => import('../clientSide/formFillinPageChild/batchSearch'),
  },
  created() {
  },
  methods: {
    debounceInputSearch: debounce(function () {
      this.OnInputSearch()
    }, 200),
      dealShowName(data) {
        return getOrgShowName(data)
      },
    // 新增分组
     addGroup () {
      this.$prompt('请输入分组名称', '新增分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '分组名称不能为空'
      }).then(async ({ value }) => {
        const obj = {
          name: value
        }
        if(this.grouping === 1){
          obj.approvalId = this.approvalId
        }
        // 从空间进入，需要传空间id
        if(this.isSpace){
          let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
          obj.spaceid = spaceId;
        }
        else if (this.isUpace) {
          let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
          obj.upaceid = upaceId
        }
        const { code, msg } = await adduserfolder(obj)
        if (code === 0) {
          await this.$refs.userGruoup.getGroup(true)
         
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 进入修改\修改用户操作
    groupSet () {
      if (this.showType !== 2) return
      this.isEditGroup = !this.isEditGroup 
    },
    async getuserlevel() {
      if (this.$route.path.includes('website')) return
      const res = await getuserlevel()
      if (res.code === 0) {
        this.userStatus = res.data
        if (res.data !== 3) {
          this.userSelect = 'space'
        }
      }
    },
    userSelectChange() {
      this.treekey++
    },
    multipleChoiceMethod(item, itemData) {
      this.getuserlevel()
      console.log(this.$refs, 'resf')
      this.multipleChoiceParms = item
      console.log('点击打开选择', item,item.hideChangeRole)
      console.log("itemData--",itemData);
      
      item = item ? JSON.parse(JSON.stringify(item)) : {}
      this.isorgs = item.isorgs
      this.isDefaultVal = item.isDefaultVal
      this.isrole = item.isrole
      this.isGroup = item.isGroup
      this.grouping = item.grouping
      this.showBatch = item.showBatch
      this.hideChangeRole = item.hideChangeRole ? true : false
      this.channelFrom = item.channelFrom
      this.isShowID = item.isShowID
      this.relationMoreTag = item.relationMoreTag
      this.approvalId = item.approvalId
      this.isuser = item.isuser
      this.key = item.key
      this.checkedArrUser = item.checkedArrUser || item.checkedUserArr || [] // 选中的用户,老数据还是 checkedUserArr
      this.checkedGroupArr = item.checkedGroupArr || []
      this.checkedUser = []
      this.checkedArrUser.forEach(element => {
        this.checkedUser.push(element.userId)
      })
      if (item.maxCount) this.maxCount = Number(item.maxCount)
      // apiurl true就是后台的
      // 是否单选  如果只能单选，那就组织和角色或者用户都只能选择一个，提交的时候做判断只能选择一个
      // 如果只单选用户 onlyUser 需要为true，
      // 如果单选，并且只选成为为false，那么就是角色或者组织的单选，如果单选为true，并且只选成为为true，那就是成员的单选，只选成为为true，isuser必须为false
      this.radio_ = item.radio_ ;// 单选情况下
      this.isEquired = item.isEquired || false
      if(item.isorgs && item.isrole && item.isuser){//配置了两个都不能选
        this.dialogMultipleChoiceVisible = false
        this.$message.error('系统配置了不能选择，请联系管理员!');
        return false;
      }
      this.checkedFlowArr = item.checkedFlowArr || [] // 选中的组织
      // 组织的选项  leaf 是否可以展开下级 checkedArr 选中的数据 onlyUser为false，并且单选，就只能单选组织
      this.settingOrg = {apiurl: item.apiurl, onlyUser: item.onlyUser, option: item.lookCustomArr, leaf: item.leafOrg, checkedArr: this.checkedFlowArr, radio: item.radio_, isLook: item.isLook }
      // 组织控件-组织查看范围
      if(item.lookRMSIsOrg){
        this.settingOrg.lookRMSIsOrg = item.lookRMSIsOrg
      }
      // 组织控件-组织查看范围选择同级组织的时候，调用新的接口
      if(item.orgEqual){
        this.settingOrg.orgEqual = item.orgEqual
      }
      if(item.iManageIt) {
        this.settingOrg.iManageIt = item.iManageIt
      }
      // 组织控件-组织查看范围选择全部组织的时候，传入可选择标签值
      if(item.orgLabel){
        this.settingOrg.orgLabel = item.orgLabel
      }
      if (itemData && itemData.gradedPermission) {
        this.settingOrg.gradedPermission = itemData.gradedPermission
      }
      // 搜索框右侧批量查找需要用到的参数
      if(itemData){
        this.batchSearhData = itemData
      }
      // 角色配置
      this.checkedRoleArr = item.checkedRoleArr || [] // 选中的角色
      // onlyUser：是否只选用户 option 固定的选项，leaf 是否可以展开下级 checkedArr 选中的数据 onlyUser为false，并且单选，就只能单选组织
      this.settingRole = {apiurl: item.apiurl, onlyUser: item.onlyUser, option: item.lookCustomArrRole, leaf: item.leafRole, checkedArr: this.checkedRoleArr, radio: item.radio_ }
      this.dialogMultipleChoiceVisible = true
      this.$nextTick(()=>{
        if(!this.isuser){
          console.log(this.$refs, 'resf')
          this.$refs.usercomRef.fromParentArr(item.apiurl, this.checkedUser, this.checkedArrUser, item.CustomUserArr, item.radio_ ) //初始化，给选中的数据 CustomUserArr 用户的选项数据
        }
        if (!this.isrole){
          this.$refs.rolecomRef.fromParent(item.JsonDataRole, this.settingRole) // JsonDataRole 角色的初始化参数，settingRole配置信息
          this.onSwitchover(1)
        }
        console.log(item.isLook!=5 && !this.isorgs,'item.isLook!=5 && !this.isorgs')
        if(item.isLook!=5 && !this.isorgs){
          this.$refs.organizeRef.fromParent(item.JsonDataOrg, this.settingOrg) // JsonDataOrg 组织的初始化参数，settingRole配置信息
          this.onSwitchover(0)
        }
      })
    },
    onuserZise(user,org,role){
      return user.length+org.length+role.length
    },
    organizationSearch(){

    },
    roleSearch(){
      //所有角色权限的都只是搜索用户。不搜索角色

    },
    handleEmpty(){//清空
      if(!this.isorgs){
        this.$refs.organizeRef.resetChecked()
      }
      if(!this.isrole){
        this.$refs.rolecomRef.resetChecked()
      }
      if(!this.isuser) {
        this.$refs.usercomRef.resetChecked()
      }
    },
    handleGroup (key, value) {
      this.$refs.usercomRef?.getGroupUser(key, value)
    },
    // 分组的选中
    checkGroup (val) {
      const index = this.checkedGroupArr.findIndex(item => { return item.id === val.id })
      if (index === -1) {
        this.checkedGroupArr.push(val)
      } else {
        this.checkedGroupArr.splice(index, 1)
      }
    },
    handleOrg(key, value){ // 用户选择 组织的点击以级搜索key,1 点击当前节点，2点击选择框，
      if (key===1&&!this.isuser) {
        this.$refs.usercomRef.fromParent(value)
      } else if(key===2) { // 等于2就是本部门不含子部门
        this.settingOrg.option = value
      }
    },
    handleRole(key, value){ // 用户选择 角色的点击以级搜索key,1 点击当前节点，2点击选择框，
      if (key===1&&!this.isuser) {
        this.$refs.usercomRef.fromParent(value)
      } else if(key===2) { // 等于2 就是当前角色
        this.settingRole.option = value
      }
    },
    handleCloseGroup (tag) { // 分组的tag删除
      const index = this.checkedGroupArr.findIndex(item => { return item.id === tag.id })
      if (index !== -1) {
        this.$refs.userGruoup.deleteCheck(cloneDeep(tag))
      }
    },
    handleCloseFlow(tag) {//组织架构的tag删除
      this.$refs.organizeRef.setCheckedNodes(tag)
    },
    handleCloseRole(tag) {//角色的tag删除
      this.$refs.rolecomRef.setCheckedNodes(tag)
    },
    handleCloseUser(tag){
      if(!this.isuser) {
        this.$refs.usercomRef.resetChecked(tag)
      }
    },
    closeLevelSelect(){
      this.dialogMultipleChoiceVisible = false;
      this.$emit('close')
       //第一个参数名为调用的方法名，第二个参数为需要传递的参数
    },
    //联系人控件批量查找
    showBatchSearch(){
      if(this.channelFrom ==='cto'){
        this.$refs.batchSearchRef.fromParentMethod(this.batchSearhData, '', 'cto');
      }
      else{
        this.$refs.batchSearchRef.fromParentMethod(this.batchSearhData);
      }
      
    },
    handleBatchSearchChild(param){
      param.user.forEach(element => {
        if (!this.checkedArrUser.some(user => user.userId === element.userId)) {
          this.checkedArrUser.push(element)
        }
        if (!this.checkedUser.includes(element.userId)) {
          this.checkedUser.push(element.userId)
        }
      })
      this.$refs.usercomRef.fromParentArr(this.multipleChoiceParms.apiurl, this.checkedUser, this.checkedArrUser, this.multipleChoiceParms.CustomUserArr, this.multipleChoiceParms.radio_ )
    },
    //搜索
    async submit(){
      //设置选择不能超过100人
      this.isBtnLoading = true
      let checkLength = this.checkedArrUser.length+this.checkedFlowArr.length+this.checkedRoleArr.length
      if(this.maxCount && this.maxCount > 0 ? checkLength > this.maxCount : checkLength>500){
        this.$message.error(`最多只能选择${this.maxCount}个`);
        this.isBtnLoading = false
        return false;
      }
      // let checkUserArr = []
      // checkedUserArr 后面吧所有的checkedUserArr 都换成checkedArrUser ，就可以删除checkedUserArr
      let arrList = {key: this.key}
      let isEquiredNum = 0
      if (!this.isorgs) {
        arrList.checkedFlowArr = this.checkedFlowArr
        isEquiredNum = isEquiredNum + this.checkedFlowArr.length
      }
      if (!this.isrole) {
        arrList.checkedRoleArr = this.checkedRoleArr
        isEquiredNum = isEquiredNum + this.checkedRoleArr.length
      }
      if (this.channelFrom === 'cto') {
        arrList.checkedGroupArr = this.checkedGroupArr
      } else {
        // 选择常用的联系人添加
        for(const item of this.checkedGroupArr) {
          if (this.radio_ && this.checkedArrUser.length > 0) break;
          const obj = {
            curpage: 0,
            pagesize: 0,
            id: item.id,
            approvalId: this.approvalId
          }
          const { code, data } = await getuserlistbyfolder(obj)
          if (code === 0 && data.length > 0) {
            if (this.radio_) {
              const user = data[0]
              this.checkedArrUser = [{
                orgname: user.orgname,
                realname: user.realname,
                userId: user.userId
              }]
            } else {
              for(const user of data) {
                if (this.checkedArrUser.length >= this.maxCount) break
                const index = this.checkedArrUser.findIndex(item => { return item.userId === user.userId })
                if (index === -1) {
                  const obj = {
                    orgname: user.orgname,
                    realname: user.realname,
                    userId: user.userId
                  }
                  this.checkedArrUser.push(obj)
                }
              }
            }
          }
        }
      }
      if (!this.isuser) {
        arrList.checkedUserArr = cloneDeep(this.checkedArrUser)
        arrList.checkedArrUser = cloneDeep(this.checkedArrUser)
        arrList.userLabel = this.$refs.usercomRef.userLabel || {}
        isEquiredNum = isEquiredNum + this.checkedArrUser.length
      }
      if (this.multipleChoiceParms.onlyUser && this.channelFrom !== 'cto') {
        // 只有是联系人控件的时候  选了组织或者角色 获取组织和角色中的人
        const orgLi = this.checkedFlowArr
        const roleLi = this.checkedRoleArr
        const userLi = []
        const orgParams = { curpage: 0, pagesize: 0 }
        for (const li of orgLi) {
          if (this.batchSearhData.lookRMSIsUser === 4 && this.batchSearhData.lookCustomChild) {
            orgParams.organizationsId = li.organizationId
          } else {
            orgParams.organizationId = li.organizationId
          }
          const res = await getopenuserlist(orgParams)
          if (res.code === 0) {
            userLi.push(...res.data)
          }
        }
        for (const li of roleLi) {
          const res = await getopenuserlist({ curpage: 0, pagesize: 0, roleId: li.roleId })
          if (res.code === 0) {
            userLi.push(...res.data)
          }
        }
        if (arrList.checkedUserArr) {
          arrList.checkedUserArr.push(...userLi)
        } else {
          arrList.checkedUserArr = userLi
        }
        const _maxCount = this.maxCount && this.maxCount > 0 ? this.maxCount : 500
        if (arrList.checkedUserArr.length > _maxCount) {
          this.$message.error(`所选超过人数上限`);
          this.isBtnLoading = false
          return false
        }
      }
      this.isBtnLoading = false
      // 组织空间（分配组织、分配角色）
      if(this.isDefaultVal){
        let obj = {}
        let valArr = []
        // 分配角色
        if(!this.isrole){
          this.checkedRoleArr.forEach(el => {
            let elObj = {
              name: el.name,
              roleId: el.roleId,
              checked: el.checked || false,
            };
            valArr.push(elObj);
          });
          obj.signrole = valArr
        }
        else return false;
        console.log("valArr=",valArr)
        axiosBase(obj,"/api/updateschoolorgandrole").then(res => {
          console.log("res=",res)
          if(res.code == 0){
            this.$message.success(res.msg);
            this.dialogMultipleChoiceVisible = false;
          }
          else{
            this.$message.error(res.msg);
          }
          return false;
        });
      }
      if(this.isEquired && !isEquiredNum){
        this.$message.error('请最少选择一个组织结构或者角色!');
      }else{
        if (this.approvalId && arrList.checkedArrUser && arrList.checkedArrUser.length > 0) {
          this.addHistoryUser(arrList)
        }
        this.$emit('fromMultipleChoice',{...arrList})
        this.dialogMultipleChoiceVisible = false;
      }
    },
    // 新增最近选择用户
    async addHistoryUser (userArr) {
      const userIds = userArr.checkedArrUser.map(item => { return item.userId }).join(',')
      const obj = {
        userIds
      }
      if(this.grouping === 1){
        obj.approvalId = this.approvalId
      }
      await addapprovaluserchose(obj)
    },
    OnInputSearch () {
      console.log("this.isuser==",this.isuser,this.inputSearch);
      
      if (!this.isuser) { // 如果有用户，都搜索用户
        let pargam = {curpage: 1,pagesize: 100,names: this.inputSearch}
        if (!this.isorgs && this.showType===0 && this.settingOrg.option) { //组织底下用户
          this.settingOrg.option =  typeof (this.settingOrg.option) == "string" ? JSON.parse(this.settingOrg.option) : this.settingOrg.option
          let organizationIdss = []
          this.settingOrg.option.forEach(item =>{
            organizationIdss.push(item.organizationId)
          })
          pargam.organizationsId = organizationIdss.join(',')
        } else if (!this.isrole && this.showType===1 && this.settingRole.option) { // 角色底下用户
          this.settingRole.option =  typeof (this.settingRole.option) == "string" ? JSON.parse(this.settingRole.option) : this.settingRole.option
          let rolesId = []
          this.settingRole.option.forEach(item =>{
            rolesId.push(item.roleId)
          })
          pargam.rolesId = rolesId.join(',')
        }
        if (this.userSelect === 'platform') {
          delete pargam.spaceid
        } else if (this.userSelect === 'space') {
          pargam.spaceid = this.$route.query.spaceid
        } else if (this.userSelect === 'upace') {
          pargam.upaceid = this.$route.query.upaceid
        }
        this.$refs.usercomRef.fromParentSearch(this.inputSearch,pargam)
      } else if (this.showType === 0) { // 否则如果是角色，就搜索角色
        this.$refs.organizeRef.fromParentSearch(this.inputSearch)
      } else if (this.showType === 1) { //否则就是组织
        // 空间配置平台角色
        if(this.hideChangeRole){
          // 搜索值为空，重新初始化树形结构配置的角色
          if(this.inputSearch === '' || this.inputSearch === undefined){
            this.$refs.rolecomRef.fromParent('', this.settingRole)
            this.$refs.rolecomRef.reloadNode()
          }
          else{
            let roleData = JSON.parse(JSON.stringify(this.settingRole))
            roleData.option = roleData.option.filter(item => item.name.includes(this.inputSearch));
            this.$refs.rolecomRef.fromParent('', roleData)
            this.$refs.rolecomRef.reloadNode()
          }
        }
        else{
          this.$refs.rolecomRef.fromParentSearch(this.inputSearch, this.userSelect)
        }
      }
    },
    onSwitchover(key){
      this.inputSearch = ''
      this.isEditGroup = false
      if (!this.isuser) {
        this.$refs.usercomRef.fromParentSearch()
      }
      // 0 组织 1 角色  2 常用
      this.showType = key
    },
  },
	mounted() {
    console.log('联系人初始化====')
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .customDialog{
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__header {
      padding: 20px;
      padding-bottom: 10px;
    }
  }
</style>
<style lang="scss" scoped>
  $border-color: #D8D8D8;
  :deep(.search-item .el-input-group__append) {
    background-color: #4e86ff;
    color: #ffffff;
    border: 1px solid #4e86ff;
  }
  .box{
    margin: 10px;
    border: 1px solid $border-color;
    overflow: hidden;
    .header{
      padding: 0 10px;
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid $border-color;
      overflow: hidden;
      position: relative;
      .sub-menu-item {
        display: inline-block;
        vertical-align: middle;
        line-height: 42px;
        height: 42px;
        margin: 0 10px;
        cursor: pointer;

        .icon-shezhi21 {
          color: #4E86FF;
          font-size: 14px;
        }
      }
      .role-select-item {
        position: absolute;
        left: 120px;
        top: 0;
      }
      .search-item{
        position: absolute;
        right: 10px;
        top: 0;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn-search{
          display: block;
          width: 26px;
          height: 26px;
          line-height: 26px;
          margin-left: 10px;
          border-radius: 4px;
          text-align: center;
          color: #4e86ff;
          background-color: #FFFFFF;
          border: 1px solid #CCCCCC;
        }
      }
      .menuActive{
        border-bottom: 3px solid #4e86ff;
      }
    }
    .content{
      overflow: hidden;
      display: flex;
      .conbox{
        display: inline-block;
        overflow: hidden;
        border-right:1px solid $border-color;
        &:last-child{
          border: 0;
        }
      }
      .w100 {
        width: 100%;
      }
      .w240 {
        width: 240px;
        :deep(.userbox) {
          .usersList {
            .more-tag {
              display: none !important;
            }
          }
        }
      }
      .w437 {
        width: 437px;
        :deep(.userbox) {
          .usersList {
            .more-tag {
              display: none !important;
            }
          }
        }
      }
    }
  }
  .footer{
    text-align: right;
    padding: 10px;
  }
  :deep(.choose-type1) {
    background: #FFE7E8;
    color: #FC6D70 !important;
    padding:2px 5px;
    border-radius: 2px;
    margin-left: 5px;
  }
  :deep(.choose-type2) {
    background: #FFEADB;
    color: #FB851C !important;
    padding:2px 5px;
    border-radius: 2px;
    margin-left: 5px;
  }
</style>
